<template>
  <div class="store">
    <header>
      <div class="banner">
        <h3>高性能运维监控软件</h3>
        <h4>ClusterMom</h4>
        <transition
          enter-active-class="animate__animated animate__bounceInDown"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="circle pa" v-show="isShow">
            <img src="@/assets/imgstore/store-banner-circle.png">
          </div>
        </transition>
        <transition
          enter-active-class="animate__animated animate__bounceInDown banner-equip"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="equip pa" v-show="isShow">
            <img src="@/assets/imgstore/about-banner-computer.png">
          </div>
        </transition>
      </div>
    </header>
    <div class="main">
      <div class="center pa">
        <img src="@/assets/imgstore/software-circle.png" alt="" />
        <h3>Cluster<br/>Mom</h3>
      </div>
      <div class="item item1 pa">
        <img src="@/assets/imgstore/main2.png">
        <h4>异构融合</h4>
        <p>平台可搭建在X86/ARM服务器上，支持X86、ARM混合集群，<br/>不限品牌与型号，拒绝捆绑</p>
      </div>
      <div class="item item2 pa">
        <img src="@/assets/imgs/software-work.png">
        <h4>作业管理</h4>
        <p>支持LSF、Slurm主流作业调度系统。实时队列、节点、用户、作业监控 提交作业 历史作业查询</p>
      </div>
      <div class="item item3 pa">
        <img src="@/assets/imgs/software-warnning.png">
        <h4>告警预报</h4>
        <p>机器硬件设备告警  资源阈值告警<br/>作业异常告警 告警转发邮件/钉钉/微信</p>
      </div>
      <div class="item item4 pa">
        <img src="@/assets/imgs/software-pay.png">
        <h4>计费统计</h4>
        <p>实时作业计费（后计费）<br/>计费统计周/月/年报 自定义计费规则</p>
      </div>
      <div class="item item5 pa">
        <img src="@/assets/imgs/software-monitor.png">
        <h4>资源监控</h4>
        <p>CPU、内存、网络、磁盘IO资源监控<br/>资源管理/监控大屏</p>
      </div>
    </div>
    <div class="cert-wrapper">
      <h3>界面展示</h3>
      <div class="cert">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide class="scroll-content">
            <img src="@/assets/imgstore/software-monitor1.png">
          </swiper-slide>
          <swiper-slide class="scroll-content">
            <img src="@/assets/imgstore/software-monitor2.png">
          </swiper-slide>
          <swiper-slide class="scroll-content">
            <img src="@/assets/imgstore/software-monitor3.png">
          </swiper-slide>
          <swiper-slide class="scroll-content">
            <img src="@/assets/imgstore/software-monitor4.png">
          </swiper-slide>
        </swiper>
        <span class="arrow" @click="() => $refs.mySwiper.swiperInstance.slidePrev()"></span>
        <span class="arrow arrow-right" @click="() => $refs.mySwiper.swiperInstance.slideNext()"></span>
      </div>
    </div>
    <div class="caser-warpper">
      <div class="caser">
        <h2>客户案例</h2>
        <div class="case">
          <a href="javascript:void(0)">
            <img src="@/assets/imgstore/school-sj.png" style="width:460px"/>
          </a>
          <a href="javascript:void(0)">
            <img src="@/assets/imgs/home-custom3.png"/>
          </a>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-cont">
        <div class="logo">
          <img src="@/assets/imgs/logo.png">
        </div>
        <div class="contact">
          <h4>联系我们</h4>
          <p>地址：南京市江北新区腾飞大厦A座4楼</p>
          <p>电话：025-68155007</p>
        </div>
        <div class="qr">
          <img class="tu" src="@/assets/imgs/home-qr.png">
          <br>
          <span class="spa">关注我们</span>
        </div>
      </div>
    </div>
    <div class="footer footer2">
      <p>版权所有 © 南京信易达计算技术有限公司 <a style="color: rgba(255,255,255, .4);" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2021021510号-1</a> 苏公网安备 0000000000号</p>
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import "animate.css";
import "swiper/swiper.min.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  name: "home",
  data() {
    return {
      isShow: false,
      state: store.state,
      // isShowContaner: false,

      swiperOption: {
        observer: true,
        // direction: "vertical",
        slidesPerView: "auto",
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        mousewheel: true,
        loop: true,
        on: {
          // 这里注册事件
        }
      }
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      this.isShow = true;
    }, 100);
  },
  watch: {
    "state.scrollTop"(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;

      // this.isShowContaner = val > 1000 && val < 2000;
    },
    "$refs.mySwiper.swiperInstance.activeIndex" (val, oldVal) {
      console.log("$refs.mySwiper.swiperInstance.activeIndex:", val, oldVal);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.store {
  header {
    height: 430px;
    background: #006BBF linear-gradient(to right, #348ad1, #0073CE);
  }
  .banner {
    width: 1200px;
    text-align: center;
    margin: 0 auto;
    padding-top: 100px;
    height: 330px;
    position: relative;
    h3, h4 {
      font-size: 50px;
      color: #fff;
      text-align: left;
    }
    h4 {
      opacity: .8;
    }
    .circle {
      right: -100px;
      top: 0;
      width: 698px;
      height: 380px;
      z-index: 1;
      overflow: hidden;
      padding-top: 50px;
      img {
        width: 90%;
        animation: imgRotate 10s infinite linear;
        transform-origin: center center;
      }
    }
    .equip {
      position: absolute;
      bottom: -50px;
      right: 100px;
      width: 318px;
      height: 338px;
      z-index: 2;
      img {
        width: 100%;
      }
    }
    .banner-equip {
      animation-delay: 300ms;
    }
  }
}
.main {
  width: 1200px;
  height: 600px;
  margin: 100px auto;
  position: relative;
  .center {
    width: 562px;
    height: 562px;
    top: 60px;
    left: 319px;
    img {
      position: absolute;
      width: 562px;
      height: auto;
      animation: shine 10s infinite linear;
    }
    h3 {
      font-size: 45px;
      color: #fff;
      text-align: center;
      line-height: 60px;
      padding-top: 225px;
      position: relative;
      z-index: 2;
    }
  }
  .item {
    box-sizing: border-box;
    width: 500px;
    padding-left: 90px;
    text-align: left;
  }
  .item img {
    position: absolute;
    left: 0;
    top: 10px;
    width: 68px;
    height: 68px;
    margin: auto;
    display: block;
    margin-bottom: 5%;
  }
  .item h4 {
    font-size: 20px;
    color: #008CFB;
    margin-bottom: 3%;
  }
  .item p {
    font-size: 14px;
    line-height: 26px;
    color: #465373;
  }
  .item1 {
    left: 580px;
    top: 0;
  }
  .item2 {
    left: 850px;
    top: 200px;
    width: 350px;
  }
  .item3 {
    left: 800px;
    top: 460px;
    width: 350px;
  }
  .item4 {
    text-align: right;
    padding-left: 0;
    padding-right: 80px;
    img {
      left: auto;
      right: 0;
    }
    left: 50px;
    top: 450px;
    width: 350px;
  }
  .item5 {
    text-align: right;
    padding-left: 0;
    padding-right: 80px;
    img {
      left: auto;
      right: 0;
    }
    left: 20px;
    top: 160px;
    width: 350px;
  }
}

.cert-wrapper {
  position: relative;
  align-content: center;
  margin: 0 auto;
  width: 1200px;
  padding: 100px 0 100px;
  height: 650px;
  text-align: center;
  h3 {
    padding-bottom: 40px;
    font-size: 35px;
    color: #465373;
  }
  .scroll-content {
    img {
      height: 600px;
    }
  }
  .arrow {
    position: absolute;
    width: 36px;
    height: 36px;
    background: url(../assets/imgstore/software-left.png) no-repeat;
    background-size: 100% 100%;
    left: 0;
    top: 450px;
    z-index: 100;
    cursor: pointer;
    transition: all 200ms;
    &.arrow-right {
      right: 0;
      left: auto;
      transform: rotate(180deg);
      &:hover {
        transform: rotate(180deg) scale(1.2);
      }
    }
    &:hover {
      transform: scale(1.2);
    }
  }
}

.caser-warpper {
  width: 100%;
  height: 400px;
  background: #f8f6f6;
  padding: 50px 0 0;
}
.caser {
  width: 1200px;
  margin: 0 auto;
  h2 {
    text-align: center;
    font-size: 35px;
    color: #465373;
    padding-bottom: 50px;
  }
  .case {
    display: flex;
    justify-content: space-around;
    align-items: center;
    a {
      transition: 500ms all;
      cursor: pointer;
    }
    a:hover {
      transform: scale(1.2);
    }
  }
  .case img {
    width: 400px;
  }
}

.footer {
  background: #2b2b2b;
  // height: 100px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  .footer-cont {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 130px;
      padding: 20px 0 0;
      img {
        width: 120px;
        background: rgba(255, 255, 255, .9);
        padding: 5px 8px;
        border-radius: 5px;
      }
    }
    .contact {
      flex: 1;
      padding: 20px 0 0 10%;
      line-height: 26px;
      h4 {
        color: rgba(255, 255, 255, 0.69);
        font-size: 16px;
        padding-bottom: 10px;
      }
    }
    .qr {
      width: 80px;
      padding: 20px 0;
      text-align: center;
      img {
        width: 80px;
        margin-bottom: 10px;
      }
    }
  }
}
.footer2 {
  background: #2b2b2b;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

@keyframes imgRotate {
  0 {
    opacity: 1;
    transform: rotate(0deg);
  }
  50% {
    opacity: 0.7;
    transform: rotate(180deg) scale(1.1);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

@keyframes shine {
  0 {
    opacity: 1;
  }
  50% {
    opacity: 0.9;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Software.vue